import { z } from 'zod';
import { addPublishWindowIssues, adminMetadataSchema, contentStatusChangeSchema, imageReferenceSchema, nonEmptyUpdate, publishWindowShape, } from './common.js';
const ofertaEditableShape = {
    titulo: z.string().min(1),
    descripcion: z.string().min(1),
    imagenUrl: imageReferenceSchema,
    categoria: z.string().min(1),
    ordenVisualizacion: z.number().int(),
};
const ofertaWriteShape = { ...ofertaEditableShape, ...publishWindowShape };
export const createOfertaSchema = z
    .object({
    ...ofertaEditableShape,
    status: publishWindowShape.status.optional(),
    publishAt: publishWindowShape.publishAt.optional(),
    unpublishAt: publishWindowShape.unpublishAt.optional(),
})
    .superRefine(addPublishWindowIssues);
export const updateOfertaSchema = nonEmptyUpdate(z.object(ofertaWriteShape));
export const ofertaStatusChangeSchema = contentStatusChangeSchema;
export const publicOfertaSchema = z.object({
    titulo: ofertaEditableShape.titulo,
    descripcion: ofertaEditableShape.descripcion,
    imagenUrl: ofertaEditableShape.imagenUrl,
    categoria: ofertaEditableShape.categoria,
    unpublishAt: publishWindowShape.unpublishAt,
});
export const publicOfertaListSchema = z.array(publicOfertaSchema);
export const publicOfertaFields = Object.freeze(Object.keys(publicOfertaSchema.shape));
export const adminOfertaSchema = z
    .object({ id: z.number().int().positive(), ...ofertaWriteShape })
    .extend(adminMetadataSchema.shape);
export const adminOfertaListSchema = z.array(adminOfertaSchema);
export const ofertaPreviewSchema = z.object({
    content: publicOfertaSchema,
    effectiveVisibility: adminMetadataSchema.shape.effectiveVisibility,
    publishAt: publishWindowShape.publishAt,
    unpublishAt: publishWindowShape.unpublishAt,
});
//# sourceMappingURL=ofertas.js.map